import React, { useEffect, useState } from 'react'
import { message } from 'antd'
import request from '../../utils/request'
import Checkbox from '../../baseComponent/checkbox'
import Button from '../../baseComponent/button'
import targetCategory from '../../common/targetCategory'
import Modal from '../modal'
import styles from './index.module.less'

// type associated 关联 confirm 确认
export default ({ visible, onClose, collectId, onOk, type = 'confirm', onCreateTask }) => {
  const confirm = type === 'confirm'
  const [option, setOption] = useState([])
  const [tasks, setTasks] = useState([])
  const [loading, setLoading] = useState(true)
  console.log('collectId', collectId)
  useEffect(() => {
    if (!collectId) {
      setLoading(false)
      return
    }
    request.get('/zhikuan/ins/blog/mission/recommend-target', { params: { collectId } }).then(res => {
      const _data = res.map(item => {
        return {
          ...item,
          value: item.id,
          disabled: item.hasBeenRelated,
        }
      })
      const _tasks = _data.filter(item => item.recommend || item.hasBeenRelated).map(item => item.value)
      setTasks(_tasks)
      setOption(_data)
      setLoading(false)
    })
  }, [])

  const _onOk = async () => {
    if (!tasks.length) {
      message.error('请选择任务')
      return
    }
    const success = await request.post('/zhikuan/ins/blog/mission/blog-related-target', { collectId, targetIdList: tasks })
    if (success) {
      message.success('关联任务成功')
      onOk?.(success)
    }
  }

  const onChange = (val) => {
    const _index = tasks.findIndex(i => i === val)
    if (_index !== -1) {
      tasks.splice(_index, 1)
    } else {
      tasks.push(val)
    }
    setTasks(pre => [...pre])
  }

  return <Modal
    visible={visible}
    onClose={onClose}
    footer={<div>
      {
        !confirm ? <Button type="normal" onClick={onClose} style={{ marginRight: 8, width: 88 }}>取消</Button>
          : <span onClick={onClose} style={{ color: 'var(--m-text-2)', marginRight: '24px', cursor: 'pointer' }}>不加入任务只采集</span>
      }
      <Button type="primary" style={{ width: 88 }} onClick={_onOk}>确定</Button>
    </div>}
    style={{
      width: '480px',
      borderRadius: '9px'
    }}
    title={null}
  >
    <div className={styles['mn-associate-task-content']}>
      <div className="mn-associate-task-header">{confirm ? '任务确认' : '手动关联任务'}</div>
      <div className="mn-associate-task-title">
        <div className="choose-task-select-title">选择任务</div>
        {
          !confirm && <div className="choose-task-select-title-right">将该款式加入我在该灵感集中参与的选款任务</div>
        }
      </div>
      <div className="choose-task-select-tile">
        {
          option.length ? option.map(item => <div
            className="choose-task-select-tile-item"
          >
            <Checkbox
              disabled={item.hasBeenRelated}
              checked={tasks.some(i => i === item.value)}
              onChange={() => {
                onChange(item.value, item)
              }}
            />
            <div className="choose-task-select-tile-item-name text-overflow">{item.missionName}</div>
            <div className="choose-task-select-tile-item-num">{item.doneNum}/{item.targetNum}</div>
            <div className="choose-task-select-tile-item-label text-overflow">{targetCategory(item.gender, item.rootCategory, item.category)}</div>
          </div>) : <div className="choose-task-select-tile-empty">
            {!loading && <div onClick={() => onCreateTask?.()}>新建选款任务</div>}
          </div>
        }
      </div>
    </div>
  </Modal>
}
